import { WidgetTypes } from '@ardoq/api-types';
import { formatNumber, Locale } from '@ardoq/locale';
import { PercentageWidgetProps } from './types';
import { PercentageWidgetRenderData } from '../renderTypes';
import { DashboardModes } from '../../types';
import type { I18nLocale } from '@ardoq/i18n';

export const getPercentageWidgetProps = (
  { data }: PercentageWidgetRenderData,
  userLocale: Locale,
  dashboardMode: DashboardModes,
  i18nLocale: I18nLocale
): PercentageWidgetProps & {
  viewType: WidgetTypes.PERCENTAGE;
} => {
  const { numerator, denominator } = data ?? { numerator: 0, denominator: 0 };
  const hasZeroResults = denominator === 0;
  const percentage = hasZeroResults ? 0 : numerator / denominator;
  const formattedPercentage = formatNumber(
    percentage,
    'percentage',
    userLocale
  );

  return {
    formattedPercentage,
    formattedNumerator: formatNumber(numerator, 'integer', userLocale),
    formattedDenominator: formatNumber(denominator, 'integer', userLocale),
    hasZeroResults: hasZeroResults,
    viewType: WidgetTypes.PERCENTAGE,
    dashboardMode,
    i18nLocale,
  };
};
